module.exports = __webpack_public_path__ + "assets/f09ddc5beee031d40b07d4044aeb712f.mp3";